import { Stack } from '@mui/material';
import axios from 'axios';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CustomButton,
  SaveButton,
  CloseButton,
} from '../../../components/common/button/CustomButtons';
import { Loader } from '../../../components/common/Loader';
import ModalCustom from '../../../components/common/Modal';
import useConfirm from '../../../components/common/useConfirm';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import useGetData from '../storeSetup/helpers/useGetData';
import TController from './components/TController';
import RackTabs from './components/RackTabs';
import { SearchBar } from '../../../components/common/SearchBar';
import { apiConstant } from './helpers/constant';
import AddRiPartTable from './components/AddRiPartTable';

const Create = () => {
  const navigate = useNavigate();
  const [selectedRowIdx, setSelectedRowIdx] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const isView = useQuery('isView') === 'true' ? true : false;

  const {
    rackId,
    racksData,
    setRacksData,
    isLoading,
    setUseEffectRender,
    compartmentData,
    handleCompartmentData,
    tabValue,
    setTabValue,
    addCompartment,
  }: any = useGetData();

  const [DialogClose, confirmClose] = useConfirm(
    'CLOSE',
    'Are you sure you want to leave this page?'
  );

  const [DialogSave, confirmSave] = useConfirm(
    'SAVE',
    'Are you sure you want to save?'
  );

  const handleSubmit = async () => {
    const ans = await confirmSave();
    if (!ans) return;

    axios
      .post(`/api/${apiConstant.compartmentroute}`, compartmentData)
      .then((res) => {
        alert('create successfully');
      })
      .catch((err) => console.log(err));
  };

  const handlePartAddModal = useCallback((rowIndex: number) => {
    setOpenModal(true);
    setSelectedRowIdx(rowIndex);
  }, []);

  const handleSaveTableData = (data: any) => {
    const riPartIdData = data.reduce((acc: any, part: any) => {
      const key = part?.ri_part_id?._id;
      const quantity = parseInt(part.quantity, 10);
      acc[key] = (acc[key] || 0) + quantity;
      return acc;
    }, {});
    handleCompartmentData(selectedRowIdx, 'initial_data', data);
    handleCompartmentData(selectedRowIdx, 'ri_part_id', riPartIdData);
    setOpenModal(false);
  };
  // console.log(compartmentData);
  return (
    <>
      <Loader loader={isLoading} />

      <ChildHeader text="Store Location list">
        <SaveButton
          sx={{ background: '#1864ab' }}
          label="Save And Continue"
          onClick={() => handleSubmit()}
        />
        <CloseButton
          label="Close"
          onClick={async () => {
            const ans = await confirmClose();
            if (!ans) return;
            navigate(-1);
          }}
        />
      </ChildHeader>

      <RackTabs
        {...{
          racksData,
          setRacksData,
          tabValue,
          setTabValue,
          setUseEffectRender,
        }}
      />
      <Stack
        direction="row"
        sx={{
          justifyContent: 'start',
          pl: 2,
          pb: 1,
          pt: 1,
          gap: 2,
        }}
      >
        <SearchBar label="Search" sx={{ width: '80%' }} />
        <CustomButton
          disabled={!rackId}
          sx={{
            backgroundColor: '#1c7ed6',
          }}
          onClick={async () => {
            // const ans = await confirmAddRow();
            // if (!ans) return;
            addCompartment();
          }}
        >
          ADD COMPARTMENT
        </CustomButton>
      </Stack>
      <TController
        {...{
          isView,
          compartmentData,
          handlePartAddModal,
          handleCompartmentData,
        }}
      />

      <ModalCustom
        title="Initial Part List"
        openModal={openModal}
        closeModal={() => {
          setOpenModal(false);
        }}
      >
        <AddRiPartTable
          {...{ handleSaveTableData, setOpenModal }}
          initialData={
            compartmentData?.[selectedRowIdx]?.initial_data?.length > 0
              ? [...compartmentData?.[selectedRowIdx]?.initial_data]
              : null
          }
        />
      </ModalCustom>
      <DialogSave isSubmitContent={true} />
      <DialogClose isSubmitContent={false} />
    </>
  );
};

export default Create;
